const host = window.location.host;

let api_base: string;
let app_token: string;

if (host.startsWith('app.')) {
  // PROD main
  api_base = 'https://api.advantagecomplete.ca';
  app_token = 'zHeRDGkDTgmNdD65BqSIYag0a3tezfUasd8rra7AJQ3FLf38tm1Auu732PK1NYYg';
} else if (host.startsWith('demo.')) {
  // PROD demo
  api_base = 'https://demo.api.advantagecomplete.ca';
  app_token = 'b4130b9099686553155819a47dd3826eaf906954a3aa0895fcf8e48a437d114c';
} else {
  // Fallback / local
  api_base = 'https://api.advantagecomplete.ca';
  app_token = 'zHeRDGkDTgmNdD65BqSIYag0a3tezfUasd8rra7AJQ3FLf38tm1Auu732PK1NYYg';
}

export const environment = {
  production: true,
  host: host,
  api_url: `${api_base}/api`,
  app_token: app_token,
  pusher: {
    key: '33df1cdd29d26a7fe961',
    cluster: 'us2',
  },
  firebase: {
    apiKey: 'AIzaSyAId5t7Bs5Y36GRtH6ZEhD5I3sYD88wxHk',
    authDomain: 'advantage-connect-prod2.firebaseapp.com',
    projectId: 'advantage-connect-prod2',
    storageBucket: 'advantage-connect-prod2.firebasestorage.app',
    messagingSenderId: '8312002004',
    appId: '1:8312002004:web:2021ab50cae2a555c7f241',
    measurementId: 'G-RMKFPHQTYR',
  }
};
